import { render, staticRenderFns } from "./PatientCIE10Component.vue?vue&type=template&id=0037c90b&"
import script from "./PatientCIE10Component.vue?vue&type=script&lang=js&"
export * from "./PatientCIE10Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports